import {APP_KEY, HTTP_URL, PHP_API_URL} from "../../../../util/constants";
import request from "../../../../util/request";
import Cookies from 'js-cookie';




//获取学科列表
export function getXuekeListRequest(
    username,
    callback) {
  let formData = new FormData();
  formData.append("appkey",APP_KEY);
  formData.append("caozuo",'get_nianji_xueke_list');
  formData.append("username",username);

  return request(PHP_API_URL+'/index.php/School/i', {
    method: "POST",
    body: formData,
  }, callback);
}



//添加学校用户
export function addSchoolTeacherRequest(
    teachersJson,
    callback) {
  let formData = new FormData();
  formData.append("appkey",APP_KEY);
  formData.append("caozuo",'add_school_teachers');
  formData.append("school_code",Cookies.get("school_code"));
  formData.append("add_teachers_json",teachersJson);

  return request(PHP_API_URL+'/index.php/School/i', {
    method: "POST",
    body: formData,
  }, callback);
}



